/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import {
  Tbody,
  Tr,
  Td,
  Button,
  Tag
} from '@chakra-ui/react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { assetsBatchesUrls } from '@/configs/urls'
import { getTagProperties } from './handlers'

const CustomTableBody = ({
  columns,
  items,
  starProcess,
  deleteProcess
}) => {
  const labelButton = {
    processing: 'View',
    draft: 'Continue',
    pending: 'Continue',
    completed: 'View'
  }
  const ColumnContent = ({ item, column }) => {
    const { id } = column

    if (id === 'state') {
      const {
        label,
        colorScheme
      } = getTagProperties(item[id])

      return (
        <Tag colorScheme={colorScheme}>
          { item[id] === 'COMPLETED_WITH_FAILS' ? 'Completed with errors' : label }
        </Tag>
      )
    }

    return item[id]
  }

  return (
    <Tbody>
      {
        items?.map(item => (
          <Tr key={item.id}>
            {columns.map(column => (
              <Td key={column.id}>
                <ColumnContent item={item} column={column}/>
              </Td>
            ))}
            <Td>
              <Button
                as={ReactRouterLink}
                size="sm"
                to={`/${assetsBatchesUrls.base}/${item.id}`}
                className="hover:text-white"
              >
                { labelButton[item.state.toLowerCase()] || labelButton.pending}
              </Button>
              { deleteProcess &&
                  <Button onClick={() => deleteProcess(item.id)} colorScheme="red">Delete</Button>
                }
            </Td>
          </Tr>
        ))}
    </Tbody>
  )
}

export default CustomTableBody
